// extracted by mini-css-extract-plugin
export default {"root":"QRQgeCGUfUmuZxTpo9iQ","buttons":"hxSvqiNFiuUHL5AKRgJ8","cartItem":"AZCgSFElUSRvfMftiP6y","placeHolderShimmer":"Wr_FCT1Z8hFo7KcstyIL"};